// extracted by mini-css-extract-plugin
export default {"npsScale":"GdprConsent_npsScale__yQUBv","npsScaleSelected":"GdprConsent_npsScaleSelected__oILx7","logo":"GdprConsent_logo__+wMtM"};